'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _AvailSegment = require('./AvailSegment.jsx');

var _AvailSegment2 = _interopRequireDefault(_AvailSegment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AvailSegments(props) {
  var segments = props.segments;


  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'AvailSegments' },
    _react2.default.createElement(
      'tbody',
      null,
      segments.map(function (segment, i) {
        return _react2.default.createElement(
          'tr',
          { key: i },
          _react2.default.createElement(
            'td',
            { style: { padding: '0' } },
            _react2.default.createElement(
              'table',
              { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'AvailJourneys__map' },
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    { style: { padding: '0' } },
                    _react2.default.createElement(_AvailSegment2.default, { segment: segment })
                  )
                ),
                i < segments.length - 1 ? _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement('td', { style: { backgroundColor: '#aaa', height: '1px', padding: '0' } })
                ) : null
              )
            )
          )
        );
      })
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(AvailSegments);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/AvailSegments.jsx
// module id = 1475
// module chunks = 0